import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc1010',
    ecrans: ['00-2', '01-2'],
    params: ['refcleint']
});
